<app-modal-generico [modelo]="modalGenerico">
  <div class="table-responsive">
    <app-tablas [page] = "paginaActual" [sizeData]="detalleProceso.paging.totalItems" (paginado)="onPaginado($event)" [headers]="headers">
      <tr *ngFor="let item of detalleProceso.items; let i=index" class="small">
        <td>{{item.usuario_creacion}}</td>
        <td>{{item.fecha_creacion  | date:'d/MMM/yyyy, h:mm a' }}</td>
        <td>{{item.numero_radicacion}}</td>
        <td>{{item.tipo_solicitud}}</td>
        <td>{{item.tipo_anotacion}}</td>
        <td [class]="item.class">{{item.dias_gestion}}</td>
        <td class="text-center">{{item.dias_limite}}</td>
        <td class="text-center">{{item.dias_diferencia}}</td>
      </tr>
    </app-tablas>
  </div>
</app-modal-generico>
